import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonViewWillEnter } from '@ionic/react';
import { useState } from 'react';
import Result from '../components/Result';

interface IRes {
  timestamp: number;
  nom: string;
  prenom: string;
  npa: string;
  categorie: string;
  genre: string;
  annee: number;
  temps: number;
}

const TabResult: React.FC = () => {
  // Ionic keeps tab pages mounted in the background, so Result's componentDidMount (where it
  // reads the scanned race from localStorage) only ever ran once. Remounting it every time this
  // tab becomes active makes sure it picks up a race that was scanned after the first visit.
  const [refreshKey, setRefreshKey] = useState(0);
  useIonViewWillEnter(() => {
    setRefreshKey(k => k + 1);
  });

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Résultats</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Course</IonTitle>
          </IonToolbar>
        </IonHeader>
        <Result items={[]} key={refreshKey} />
      </IonContent>
    </IonPage>
  );
};

export default TabResult;
